import ApiV2 from './ApiV2';
import TextHelper from '../helpers/TextHelper';

export default class EnderecoService {
  static getByCep(st_cep) {
    return ApiV2.get('/endereco/by-cep', {
      params: { st_cep: TextHelper.unmask(st_cep) },
    });
  }

  static async getPaises() {
    return ApiV2.get('/endereco/pais');
  }

  static async getUfs(id_pais) {
    return ApiV2.get('/endereco/uf', { params: { id_pais } });
  }

  static async getMunicipios(sg_uf) {
    return ApiV2.get('/endereco/municipio', { params: { sg_uf } });
  }

  /**
   *
   * @param {Object} data {
    // DADOS
    id_usuario,
    id_entidade,
    // ENDEREÇO
    st_cep = null,
    st_endereco = null,
    nu_numero = null,
    st_complemento = null,
    st_bairro = null,
    st_cidade = null,
    sg_uf = null,
    // TELEFONE
    id_tipotelefone = null,
    id_telefone = null,
    telefone = null,
    ...rest
  }
   * @returns {Promise<AxiosResponse<any>>}
   */
  static async saveEnderecoTelefone(data) {
    if (data.id_endereco) {
      return ApiV2.put(`/endereco/update/id/${data.id_endereco}`, data);
    }

    if (!('bl_padrao' in data)) {
      data.bl_padrao = 1;
    }

    return ApiV2.post('/endereco/create', data);
  }
}
